import { Base, IBaseState } from "./Base";
import { RouteComponentProps } from "react-router-dom";
import { UsersStatus } from "../Session/withAuthorization";

export interface IBaseLayoutMatchParams {
  orgId: string;
}

export interface IBaseLayoutProps<TmatchParams extends IBaseLayoutMatchParams>
  extends RouteComponentProps<TmatchParams> {
  orgId: string;
  authUser: any;
  usersStatus: UsersStatus;
}

export interface IBaseLayoutState extends IBaseState {
  none: string;
}

export class BaseLayout<
  TProps extends IBaseLayoutProps<IBaseLayoutMatchParams>,
  TState extends IBaseLayoutState
  > extends Base<TProps, TState> {
  protected static BASE_LAYOUT_INITAL_STATE = {
    ...Base.BASE_INITAL_STATE,
    none: "",
  };
  constructor(props: any) {
    super(props);
  }
}



// WEBPACK FOOTER //
// ./src/components/Common/BaseLayout.tsx